/**
 * The browser's own time zone as an IANA name ("America/Los_Angeles"). The CRM stores every moment
 * in UTC and is told the user's zone so that "today", "added on" and "days since" mean the user's
 * calendar day. Returns {} (so the service assumes UTC) if the browser cannot say.
 */
export const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch (e) {
    return '';
  }
};

export const timeZoneParam = () => {
  const tz = browserTimeZone();
  return tz ? { tz } : {};
};
